// extracted by mini-css-extract-plugin
export default {"contentMain":"ErrorModal_contentMain__gCHos","closeButton":"ErrorModal_closeButton__QhZkQ"};